import { createFiltersReducer } from '../utils';
import { ACTIONS_PREFIX } from '../actions/devicesFilters';

const initialFiltersState = {
    searchData: '',
    users: [],
    offices: [],
    resourceOwner: [],
    whereabouts: [],
    strict: false,
    officeState: 2,
    resourceOwnerState: 2,
    isDismissedEmployees: null,
    resourceOwnerStrict: false,
    deviceTypes: [],
    oSTypes: [],
    processorNameTypes: [],
    fromCoreCountTypes: [],
    toCoreCountTypes: [],
    fromDiskSizeTypes: [],
    toDiskSizeTypes: [],
    fromRamSizeTypes: [],
    toRamSizeTypes: [],
    fromRamSlotTypes: [],
    toRamSlotTypes: [],
    assignmentDateFrom: null,
    assignmentDateTo: null,
    deliveryDateFrom: null,
    deliveryDateTo: null,
    LeasingContractEndDateFrom: null,
    LeasingContractEndDateTo: null,
    LeasingContractIds: [],
    deviceManufacturers: [],
    positionsInCompany: [],
    projectsInCompany: [],
    primarySkill: [],
    roleOnProject: [],
    ids: [],
    isPrimary: null,
    isInfrastructureUnit: null,
    isReserved: false,
    isInEndpointCentral: false,
    condition: {
        working: false,
        nonWorking: false,
        workingConditionally: false
    },
    state: {
        inUse: false,
        onStock: false,
        inTransit: false,
        inOffice: false,
        underRepair: false,
        ordered: false,
        writeOff: false
    },
    primary: {
        yes: false,
        no: false
    },
    infrastructureUnit: {
        yes: false,
        no: false
    },
    leasingContract: {
        yes: false,
        no: false
    },
    pageNumber: 1,
    sortBy: 'deviceTypeName',
    sortOrder: 'asc',
    rangeOSVersion: {
        isRanged: false,
        osVersion: null
    },
    isAppliedFilter: false
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const deviceFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default deviceFiltersReducer;
